import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const customerSchemaLiteral = {
  title: 'customer',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 255 },
    phone: { type: ['string', 'null'], maxLength: 50 },
    email: { type: ['string', 'null'], maxLength: 100 },
    instagram: { type: ['string', 'null'], maxLength: 100 },
    branch_id: { type: 'string', maxLength: 100 },
    last_visited_branch_id: { type: ['string', 'null'], maxLength: 100 },
    notes: { type: ['string', 'null'] },
    credit_balance: { type: 'number' },
    debt_balance: { type: 'number' },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'branch_id', 'credit_balance', 'debt_balance', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'updated_at', 'branch_id'],
} as const;

const schemaTyped = toTypedRxJsonSchema(customerSchemaLiteral);
export type CustomerDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const customerSchema: RxJsonSchema<CustomerDocType> = customerSchemaLiteral;
